"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.OrganizationList = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _Button = _interopRequireDefault(require("../../../Button"));

var _Clear = _interopRequireDefault(require("@material-ui/icons/Clear"));

var _Fade = _interopRequireDefault(require("@material-ui/core/Fade"));

var _InputAdornment = _interopRequireDefault(require("@material-ui/core/InputAdornment"));

var _List = _interopRequireDefault(require("../../../List"));

var _Loader = _interopRequireDefault(require("../../../Loader"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TextInput = _interopRequireDefault(require("../../../TextInput"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("./styles");

var _styles2 = require("@material-ui/core/styles");

var _OrganizationHelper = require("../../../Utilities/OrganizationHelper");

var _Drawer = _interopRequireDefault(require("../../../Drawer"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var OrganizationList = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(OrganizationList, _Component);

  var _super = _createSuper(OrganizationList);

  function OrganizationList() {
    var _this;

    (0, _classCallCheck2.default)(this, OrganizationList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      availableOrgs: [],
      count: 0,
      searchVal: "",
      loading: false,
      minHeight: 0
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "menuRef", /*#__PURE__*/_react.default.createRef());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "loadOrgs", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var availableOrgs;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _this.props.identityServerSdk.GetUsersOrganizations(1, 6, ["Id", "Name"], {
                column: "Name",
                direction: "asc"
              }, _this.state.searchVal);

            case 3:
              availableOrgs = _context.sent;

              if (availableOrgs) {
                _this.setState({
                  availableOrgs: availableOrgs.items,
                  count: availableOrgs.total,
                  loading: false
                }, function () {
                  if (!_this.props.currentOrg && _this.state.count > 0 && _this.props.onOrgSelect) {
                    _this.props.onOrgSelect(_this.state.availableOrgs[0]);
                  }
                });
              }

              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              // eslint-disable-next-line no-console
              console.error(_context.t0);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleMenuToggle", function () {
      _this.props.onToggle();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleClickAway", function () {
      _this.props.onToggle(false);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "generateLinks", function () {
      var _this$props = _this.props,
          id = _this$props.id,
          onOrgSelect = _this$props.onOrgSelect,
          classes = _this$props.classes;
      var availableOrgs = _this.state.availableOrgs;
      return _this.state.loading ? /*#__PURE__*/_react.default.createElement(_Loader.default, {
        verticallyCenter: true
      }) : _this.state.count > 0 ? /*#__PURE__*/_react.default.createElement(_List.default, {
        "aria-label": "Organizations",
        className: classes.list,
        id: id + "-list",
        listItems: _this.state.count > 0 ? availableOrgs.map(function (org) {
          return {
            button: true,
            onClick: function onClick() {
              return onOrgSelect(org);
            },
            itemText: {
              primary: (0, _OrganizationHelper.formatOrgName)(org, "")
            },
            isSideNav: true,
            isProductDropdown: false,
            isOrganizationDropdown: true
          };
        }) : [{
          button: true,
          onClick: function onClick() {// do nothing
          },
          itemText: {
            primary: "Sorry, no results found"
          },
          isSideNav: true,
          isProductDropdown: false,
          isOrganizationDropdown: true
        }]
      }) : undefined;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "generateSearch", function () {
      var _this$props2 = _this.props,
          id = _this$props2.id,
          classes = _this$props2.classes;
      var _this$state = _this.state,
          searchVal = _this$state.searchVal,
          count = _this$state.count;
      return (count > 6 || searchVal) && /*#__PURE__*/_react.default.createElement("div", {
        className: classes.search
      }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
        id: id + "-search",
        label: "Search Organizations...",
        onChange: _this.doSearch,
        value: _this.state.searchVal,
        variant: "standard",
        fullWidth: true,
        autoFocus: true,
        labelProps: {
          shrink: true
        },
        endAdornment: /*#__PURE__*/_react.default.createElement(_Fade.default, {
          in: searchVal !== ""
        }, /*#__PURE__*/_react.default.createElement(_InputAdornment.default, {
          position: "end"
        }, /*#__PURE__*/_react.default.createElement(_Button.default, {
          type: "icon",
          onClick: _this.clearSearch,
          "aria-label": "Clear Organization Search",
          title: "Clear Organization Search"
        }, /*#__PURE__*/_react.default.createElement(_Clear.default, {
          fontSize: "small"
        }))))
      }));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "clearSearch", function () {
      _this.setState({
        searchVal: "",
        loading: true
      }, /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this.loadOrgs();

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "doSearch", function (event) {
      var searchVal = event.target.value;

      _this.setState({
        searchVal: searchVal,
        loading: true
      }, /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this.loadOrgs();

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      })));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "render", function () {
      var _classNames;

      var _this$props3 = _this.props,
          id = _this$props3.id,
          classes = _this$props3.classes,
          open = _this$props3.open,
          currentOrg = _this$props3.currentOrg,
          currentOrgSettings = _this$props3.currentOrgSettings;

      var links = _this.generateLinks();

      var name = (0, _OrganizationHelper.formatOrgName)(currentOrgSettings, currentOrg);
      return name ? /*#__PURE__*/_react.default.createElement(_Drawer.default, {
        id: id,
        open: open,
        SlideProps: {
          unmountOnExit: true
        },
        anchor: "bottom",
        variant: "persistent",
        classes: {
          paper: (0, _classnames.default)("prmbl-OrganizationList-wrapper", classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.canBeClicked, links), (0, _defineProperty2.default)(_classNames, classes.drawerOpen, open), _classNames))
        },
        className: classes.rootWrapper,
        modalProps: {
          BackdropProps: {
            invisible: true
          },
          className: classes.modal
        },
        onClose: _this.handleMenuToggle
      }, /*#__PURE__*/_react.default.createElement("div", {
        ref: _this.menuRef,
        className: (0, _classnames.default)("prmbl-OrganizationList-Menu", classes.menu)
      }, links, _this.generateSearch())) : null;
    });
    return _this;
  }

  (0, _createClass2.default)(OrganizationList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.identityServerSdk) {
        this.loadOrgs();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.open && this.menuRef.current) {
        if (this.state.minHeight === 0) this.setState({
          minHeight: this.menuRef.current.clientHeight + 5
        });
      } else {
        if (this.state.minHeight !== 0) this.setState({
          minHeight: 0
        });
      }
    }
  }]);
  return OrganizationList;
}(_react.Component);

exports.OrganizationList = OrganizationList;
(0, _defineProperty2.default)(OrganizationList, "propTypes", {
  /**
   * The html id
   */
  id: _propTypes.default.string.isRequired,

  /**
   * The current organization's name
   */
  currentOrg: _propTypes.default.string,

  /**
   * The current organization's branding settings
   */
  currentOrgSettings: _propTypes.default.shape({
    name: _propTypes.default.string,
    id: _propTypes.default.string,
    settings: _propTypes.default.object
  }),

  /**
   * `true` if the OrganizationList is open
   */
  open: _propTypes.default.bool.isRequired,

  /**
   * The callback to fire when toggling the component
   */
  onToggle: _propTypes.default.func.isRequired,

  /**
   * @ignore
   *
   * Utilizing this to style up the page don't want to expose this in the style guide.
   * Auto-populated by material-ui withStyles()
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * The identitySeverSdk object. Requires accessToken, identityServerBaseUrl, and idToken.
   * Used to get the user's products and information.
   *
   * If no user is specified, a blank product list will be shown and a user avatar will be hidden.
   */
  identityServerSdk: _propTypes.default.object,

  /**
   * What to do when the organization is selected.
   */
  onOrgSelect: _propTypes.default.func
});

var _default = (0, _styles2.withStyles)(_styles.styles)(OrganizationList);

exports.default = _default;